import styled from 'styled-components';
export const WrapLongText = styled.div`
  word-break: break-all;
`;
export const Price = styled.p`
  .tax-note {
    font-size: 0.9em;
  }
  .rate-card-price {
    font-size: 0.9em;
    color: #98a9bc;
    text-decoration-line: line-through;
    text-decoration-color: #c90000;
    text-decoration-thickness: 15%;
  }
`;
export const TagTitle = styled.strong`
  font-weight: 700;
`;
export const WrapContent = styled.p`
  white-space: pre-wrap;
`;
export const CXLeadContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  margin-bottom: 24px;
`;